
const hiddenProperty = (() => {
  // document[hiddenProperty] 可以判断页面是否失焦
  let names = ['hidden', 'webkitHidden', 'mozHidden', 'msHidden']
  names = names.filter(e => e in document)
  return names.length > 0 ? names[0] : false
})()
const visibilityChangeEvent = (() => {
  if (!hiddenProperty) {
    return false
  }
  return hiddenProperty.replace(/hidden/i, 'visibilitychange') // 如果属性有前缀, 相应的事件也有前缀
})()
const deepClone = function (obj) {
  // 先检测是不是数组和Object
  // let isArr = Object.prototype.toString.call(obj) === '[object Array]';
  let isArr = Array.isArray(obj)
  let isJson = Object.prototype.toString.call(obj) === '[object Object]'
  if (isArr) {
    // 克隆数组
    let newObj = []
    for (let i = 0; i < obj.length; i++) {
      newObj[i] = deepClone(obj[i])
    }
    return newObj
  } else if (isJson) {
    // 克隆Object
    let newObj = {}
    for (let i in obj) {
      newObj[i] = deepClone(obj[i])
    }
    return newObj
  }
  // 不是引用类型直接返回
  return obj
}

export default {
  // 日期格式化方法
  fmtDate (td, fmtExp) {
    if (!td) {
      return ''
    }
    let tempTD = td
    if (typeof td === 'string' && !/^[0-9]+$/.test(td)) {
      tempTD = td.replace(/-/g, '/')
    }
    if (typeof td === 'string' && /^[0-9]+$/.test(td)) {
      tempTD = Number(td)
    }
    const date = new Date(tempTD)
    const o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      S: date.getMilliseconds() // 毫秒
    }
    let dateFmt = fmtExp
    if (/(y+)/.test(dateFmt)) {
      dateFmt = dateFmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length))
    }
    for (const k in o) {
      if (new RegExp(`(${k})`).test(dateFmt)) {
        dateFmt = dateFmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length)))
      }
    }
    // dateFmt.replace(/-/g, '/')
    return dateFmt
  },
  getDate (td) {
    if (td instanceof Date) {
      const dateStr = this.fmtDate(td.getTime(), 'yyyy-MM-dd')
      let tmp = dateStr.replace(/-/g, '/')
      return new Date(tmp).getTime() - 28800000
    }
    return null
  },
  getStartDate (td) {
    return this.getDate(td)
  },
  getEndDate (td) {
    if (td instanceof Date) {
      const dateStr = this.fmtDate(td.getTime(), 'yyyy-MM-dd')
      let tmp = dateStr.replace(/-/g, '/')
      return new Date(tmp).getTime() + 57600000
    }
    return null
  },
  getTodayLastTime (td) {
    if (td instanceof Date) {
      const dateStr = this.fmtDate(td.getTime(), 'yyyy-MM-dd')
      let tmp = dateStr.replace(/-/g, '/')
      return new Date(tmp).getTime() + 57600000 - 1
    }
    return null
  },
  isFn (fn) {
    return typeof fn === 'function'
  },
  getCookie: name => {
    const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    const arr = document.cookie.match(reg)
    if (arr) {
      return unescape(arr[2])
    } else {
      return null
    }
  },
  setCookie (name, value) {
    const Days = 3000
    const exp = new Date()
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
    document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString() + ';path=/'
  },
  deleteCookie (name) {
    const exp = new Date()
    exp.setTime(exp.getTime() - 1)
    const cval = this.getCookie(name)
    if (cval != null) {
      document.cookie = `${name}=${cval};expires=${exp.toGMTString()}`
    }
  },
  hasClass (obj, cls) {
    if (obj) {
      return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
    }
    return null
  },
  addClass (obj, cls) {
    if (obj && !this.hasClass(obj, cls)) {
      if (obj.className) {
        obj.className += ' ' + cls
      } else {
        obj.className = cls
      }
    }
  },
  removeClass (obj, cls) {
    if (obj && this.hasClass(obj, cls)) {
      var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
      obj.className = obj.className.replace(reg, ' ')
    }
  },
  toggleClass (obj, cls) {
    if (this.hasClass(obj, cls)) {
      this.removeClass(obj, cls)
    } else {
      this.addClass(obj, cls)
    }
  },
  formatFile (file) {
    const format = file.name.split('.').pop().toLocaleLowerCase() || ''
    let type = 'document'
    if (['gif', 'jpg', 'jpeg', 'png', 'bmp', 'webp'].indexOf(format) > -1) {
      type = 'image'
    }
    if (['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv'].indexOf(format) > -1) {
      type = 'ios-film'
    }
    if (['mp3', 'wav', 'wma', 'ogg', 'aac', 'flac'].indexOf(format) > -1) {
      type = 'ios-musical-notes'
    }
    if (['doc', 'txt', 'docx', 'pages', 'epub', 'pdf'].indexOf(format) > -1) {
      type = 'document-text'
    }
    if (['numbers', 'csv', 'xls', 'xlsx'].indexOf(format) > -1) {
      type = 'stats-bars'
    }
    if (['keynote', 'ppt', 'pptx'].indexOf(format) > -1) {
      type = 'ios-videocam'
    }
    return type
  },
  getToken () {
    let token = this.getCookie('ssss')
    if (!token) {
      token = this.getCookie('token')
    }
    return token
  },
  isImage (items) {
    const len = items.length
    let i = 0
    let item = null

    while (i < len) {
      item = items[i]
      // 针对从word中粘贴来的内容
      if (item.type.includes('rtf')) return false
      if (item.type.includes('image')) {
        return item
      }
      i++
    }
    return false
  },
  // 常用的接口返回数据处理
  handleCommonResponse (i, res, fn) {
    if (res) {
      if (res.data.isSuccess) {
        fn(res.data)
      } else {
        i.$Message.error({
          content: res.data.resultMsg,
          duration: 5
        })
      }
    }
  },
  getModuleListByRequireContext (r) {
    let moduleList = []
    r.keys().forEach(key => {
      moduleList.push(r(key).default)
    })
    return moduleList
  },
  hiddenProperty,
  deepClone,
  visibilityChangeEvent,
  isSpaces (str) {
    const barringSpace = str.replace(/\s/g, '')
    return !barringSpace
  },
  // 小时转化为毫秒  value => HH:mm
  hourConversionMs (value) {
    let colonIndex = value.indexOf(':')
    let hour = Number(value.substring(0, colonIndex))
    let minute = Number(value.substring(colonIndex + 1))
    return hour * 3600 * 1000 + minute * 60 * 1000
  },
  // 毫秒转换为小时  HH:mm => ms
  msConversionHour (value) {
    if (typeof value === 'number' && !isNaN(value)) {
      let hour = parseInt(value / (1000 * 60 * 60))
      let minute = (value % (1000 * 60 * 60)) / (1000 * 60)
      hour = hour < 10 ? '0' + hour : hour
      minute = minute < 10 ? '0' + minute : minute
      return `${hour}:${minute}`
    }
  },
  realFormatSecond (second) {
    // 将整数转换成 时：分：秒的格式
    var secondType = typeof second
    if (secondType === 'number' || secondType === 'string') {
      second = parseInt(second)
      var hours = Math.floor(second / 3600)
      second = second - hours * 3600
      var mimute = Math.floor(second / 60)
      second = second - mimute * 60
      return hours + ':' + ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
    } else {
      return '0:00:00'
    }
  },
  // 格式化金额
  formatMoney (num) {
    let money = (num / 100).toFixed(2) + ''
    var regex = /(?!^)(?=(\d{3})+\.)/g
    return money.replace(regex, ',')
  },
  digitUppercase (n) {
    let fraction = ['角', '分']
    let digit = [
      '零', '壹', '贰', '叁', '肆',
      '伍', '陆', '柒', '捌', '玖'
    ]
    let unit = [
      ['元', '万', '亿'],
      ['', '拾', '佰', '仟']
    ]
    let head = n < 0 ? '欠' : ''
    n = Math.abs(n)
    let s = ''
    for (let i = 0; i < fraction.length; i++) {
      s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '')
    }
    s = s || '整'
    n = Math.floor(n)
    for (let i = 0; i < unit[0].length && n > 0; i++) {
      let p = ''
      for (let j = 0; j < unit[1].length && n > 0; j++) {
        p = digit[n % 10] + unit[1][j] + p
        n = Math.floor(n / 10)
      }
      s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
    }
    return head + s.replace(/(零.)*零元/, '元')
      .replace(/(零.)+/g, '零')
      .replace(/^整$/, '零元整')
  },
  transformByte (bytes) {
    if (bytes === undefined) return
    if (bytes === 0 || bytes === '0') return '0 B'
    let k = 1024
    let sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    let i = Math.floor(Math.log(bytes) / Math.log(k))
    return (bytes / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i]
  },
  getFileIcon (contentType) {
    let result = {}
    switch (contentType) {
      case 'ppt':
        result.color = '#d04424'
        result.icon = 'ibass-filetype-ppt'
        break
      case 'pptx':
        result.color = '#d04424'
        result.icon = 'ibass-filetype-ppt'
        break
      case 'pdf':
        result.color = '#e3574d'
        result.icon = 'ibass-filetype-pdf'
        break
      case 'png':
        result.color = '#07cfda'
        result.icon = 'ibass-filetype-image'
        break
      case 'jpg':
        result.color = '#07cfda'
        result.icon = 'ibass-filetype-image'
        break
      case 'jpeg':
        result.color = '#07cfda'
        result.icon = 'ibass-filetype-image'
        break
      case 'gif':
        result.color = '#07cfda'
        result.icon = 'ibass-filetype-image'
        break
      case 'doc':
        result.color = '#0a96e5'
        result.icon = 'ibass-filetype-doc'
        break
      case 'docx':
        result.color = '#0a96e5'
        result.icon = 'ibass-filetype-doc'
        break
      case 'xls':
        result.color = '#1c7044'
        result.icon = 'ibass-filetype-excel'
        break
      case 'zip':
        result.color = '#9d7120'
        result.icon = 'ibass-filetype-zip'
        break
      case 'wav':
        result.color = '#a7d638'
        result.icon = 'ibass-filetype-music'
        break
      case 'mp3':
        result.color = '#a7d638'
        result.icon = 'ibass-filetype-music'
        break
      case 'mp4':
        result.color = '#d94ff5'
        result.icon = 'ibass-filetype-video'
        break
      default:
        result.color = '#fff'
        result.icon = 'ibass-filetype-default'
    }
    return result
  }
}

export const snakeToCamelCase = (SnakeCase) => {
  let CamelCase = ''
  CamelCase = String(SnakeCase).toLowerCase().replace(/_[a-z]/g, (str) => {
    return str.slice(1).toUpperCase()
  })
  return CamelCase
}
